<template>
  <white-bg style="min-height: 250px; position:relative; z-index: 1">
    <preload-content :loading="loading" min-height="300px">
      <template v-if="!loading">
        <h3>Основные показатели</h3>
        <tabs :tabs="specializations" @changeTab="changeTab"/>
        <div class="card">
          <h4>Прибыль</h4>
          <div class="main-income">
            {{ round(analytic.income - analytic.outcome) }} ₽
          </div>
          <div class="wrap">
            <div class="col">
              <h4>Доходы</h4>
              <div class="income">
                {{ round(analytic.income) }} ₽
              </div>
            </div>
            <div class="col">
              <h4>Расходы</h4>
              <div class="income">
                {{ round(analytic.outcome) }} ₽
              </div>
            </div>
          </div>
        </div>
      </template>
    </preload-content>
  </white-bg>
</template>

<script>
import WhiteBg from '@/components/ui/white-bg'
import Tabs from '@/components/functional/Tabs'
import PreloadContent from '@/components/ui/preload-content';

export default {
  name: "General",
  components: {PreloadContent, WhiteBg, Tabs},
  props: {
    period: Object,
  },
  data() {
    return {
      specialization: null,
      specializations: null,
      analytic: null,
    }
  },
  computed: {
    loading() {
      return !this.specializations || !this.analytic;
    },
    filter() {
      return Object.assign({specialization_id: this.specialization ? this.specialization.id : ''}, this.period);
    }
  },
  watch: {
    specialization(to) {
      this.specialization = to;
      this.loadAnalytics();
    },
    'period.start'() {
      this.loadSpecializations();
    },
  },
  mounted() {
    this.loadSpecializations();
  },
  methods: {
    round(number) {
      return Math.round(number);
    },
    loadAnalytics() {
      this.$api.master.analytic.general.info(this.filter).then((data) => this.analytic = data);
    },
    loadSpecializations() {
      this.$api.master.analytic.specialization.list(this.period).then(({data}) => {
        data.unshift({id: '', name: 'Все'});
        this.specializations = data;
        this.changeTab(0);
      });
    },
    changeTab(idx) {
      this.specializations = this.specializations.map((tab, tabIdx) => {
        tab.isActive = idx === tabIdx;
        if (tab.isActive) this.specialization = tab;
        return tab;
      });
    },
  }
}
</script>

<style scoped lang="scss">
h3 {
  margin-top: -15px;
  padding-bottom: 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #383838;
}

h4 {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: #808080;
}

.card {
  padding: 15px;
  background: #FDF8F4;
  border: 1px solid #DBBFA7;
  box-sizing: border-box;
  border-radius: 10px;

  .main-income {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: #383838;
  }

  .wrap {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #383838;

    .col {
      width: 50%;
    }
  }
}
</style>
